import ProjectsDetail from "./ProjectsDetail";

export default ProjectsDetail;
